export enum ENUM_WALLETS_TYPE {
  DEPOSIT = "deposit",
  PROFIT = "profit",
  SPENDING = "individual",
  PREPAYMENT = "prepayment",
}
